import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation, Scrollbar]);

export default class FeaturedIconCarousel {
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');

        new Swiper(this.sliderElement, {
            slidesPerView: 1.5,
            spaceBetween: 20,
            threshold: 10,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true,
                hide: false
            },
            breakpoints: {
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 }
            }
        });
    }
}
